import { Component, EventEmitter } from '@angular/core';
import { DriverMedicalCertificateDecisionType } from '../../../driver/models/enums/driver-medical-certificate-decision-type.enum';
import { MedicalExamCertificateRestrictionType } from '../../../driver/models/enums/medical-exam-certificate-restriction-type.enum';
import { MedicalExamCertificateViewModel } from '../../../driver/models/requirement/medical-exam-certificate-view.model';
import { Jurisdiction } from '../../../foundation/models/enums/jurisdiction.enum';
import { MedicalReviewService } from '../../services/medical-review.service';

@Component({
    selector: 'medical-exam-certificate-history',
    templateUrl: './medical-exam-certificate-history.html',
    inputs: ['customerNumberId'],
    outputs: ['eligibilityStatus']
})
export class MedicalExamCertificateHistoryComponent {

    public medicalExamCertificateHistory: MedicalExamCertificateViewModel[];
    public customerNumberId: number;
    public showHistory = false;
    public cols: any[];
    public eligibilityStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
    public restrictionType: MedicalExamCertificateRestrictionType = new MedicalExamCertificateRestrictionType();
    public jurisdictionType: Jurisdiction = new Jurisdiction();
    public decisionType: DriverMedicalCertificateDecisionType = new DriverMedicalCertificateDecisionType();
    private signedDate: Date = new Date();

    constructor(
        private _medicalReviewService: MedicalReviewService
    ) {
        this.cols = [
            { field: 'id', header: 'Id', array: false },
            { field: 'medicalExamCertificateDecisionTypeId', header: 'Decision', array: false },
            { field: 'restrictions', header: 'Restrictions', array: true },
            { field: 'isLongMedicalExamForm', header: 'Is Long', array: false },
            { field: 'medicalExaminerRegistryCode', header: 'Registry Code', array: false },
            { field: 'medicalExamCertificateIssuingJurisdictionId', header: 'Jurisdiction', array: false },
            { field: 'medicalExamCertificateSignatureDate', header: 'Sign Date', array: false },
            { field: 'expirationDate', header: 'Expiration Date', array: false},
            { field: 'updatedDate', header: 'Updated Date', array: false },
        ];
        this.signedDate.setFullYear(this.signedDate.getFullYear() - 2);
    }

    ngOnInit() {

        let eligibility = false;

        this._medicalReviewService.getMedicalExamCertificateHistory(this.customerNumberId).subscribe(result => {

            this.medicalExamCertificateHistory = result.result;

            result.result.forEach(item => {

                item.restrictionDisplayValues = '';

                item.restrictions.forEach(restriction => {
                    item.restrictionDisplayValues += this.restrictionType.FromId(restriction.restrictionTypeId).displayValue + ', ';
                });

                item.jurisdictionDisplayValue = this.jurisdictionType.FromId(item.medicalExamCertificateIssuingJurisdictionId).displayValue;
                item.restrictionDisplayValues = item.restrictionDisplayValues.substring(0, item.restrictionDisplayValues.length - 2);
                item.decisionDisplayValue = this.decisionType.FromId(item.medicalExamCertificateDecisionTypeId).displayValue;

                if (item.medicalExamCertificateSignatureDate > this.signedDate) {
                    eligibility = true;
                }
            });

            this.eligibilityStatus.emit(eligibility);
            // TO DO: Display <customer name>  are not eligible at this time.
        });
    }

    public toggleHistory = (): void => {

        this.showHistory = !this.showHistory;
    };
}
